/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Agents_Cta_TitleInputs */

const en_svc_agents_cta_title = /** @type {(inputs: Svc_Agents_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bring the task you would hand to an agent.`)
};

const lv_svc_agents_cta_title = /** @type {(inputs: Svc_Agents_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atnesiet uzdevumu, ko uzticētu aģentam.`)
};

/**
* | output |
* | --- |
* | "Bring the task you would hand to an agent." |
*
* @param {Svc_Agents_Cta_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_agents_cta_title = /** @type {((inputs?: Svc_Agents_Cta_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Agents_Cta_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_agents_cta_title(inputs)
	return en_svc_agents_cta_title(inputs)
});